import React from 'react';

const UserContext = React.createContext({ user: 'admin' });
export default UserContext;
